module.exports = __webpack_public_path__ + "img/4-web.a6264bd5.jpg";